import type { IconNode } from '../types';

/**
 * @name stroller
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgMTIuOTVjMS42LTEuNiA0LjEtMS42IDUuNy4wNSIgLz4KICA8Y2lyY2xlIGN4PSIxMSIgY3k9IjYuNSIgcj0iMi41IiAvPgogIDxwYXRoIGQ9Ik0xOC4zIDE3LjIgNS40NSA0LjUiIC8+CiAgPHBhdGggZD0iTTE5LjcgMTcgMTMgMTguMWMtMi43LjUtNS41LTEtNS43LTQuMS0uNC0yLjYtLjktNS43LTEuMy04LjNBMiAyIDAgMCAwIDIgNiIgLz4KICA8Y2lyY2xlIGN4PSI4IiBjeT0iMTkiIHI9IjIiIC8+CiAgPGNpcmNsZSBjeD0iMjAiIGN5PSIxOSIgcj0iMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/stroller
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const stroller: IconNode = [
  ['path', { d: 'M14 12.95c1.6-1.6 4.1-1.6 5.7.05', key: '172v27' }],
  ['circle', { cx: '11', cy: '6.5', r: '2.5', key: '18uiu5' }],
  ['path', { d: 'M18.3 17.2 5.45 4.5', key: 'ln5vyk' }],
  [
    'path',
    {
      d: 'M19.7 17 13 18.1c-2.7.5-5.5-1-5.7-4.1-.4-2.6-.9-5.7-1.3-8.3A2 2 0 0 0 2 6',
      key: '115qgu',
    },
  ],
  ['circle', { cx: '8', cy: '19', r: '2', key: 't8fc5s' }],
  ['circle', { cx: '20', cy: '19', r: '2', key: '1obnsp' }],
];

export default stroller;
